import { render } from "./PublishInfo.vue?vue&type=template&id=1c533644&scoped=true"
import script from "./PublishInfo.vue?vue&type=script&lang=js"
export * from "./PublishInfo.vue?vue&type=script&lang=js"

import "./PublishInfo.vue?vue&type=style&index=0&id=1c533644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c533644"]])

export default __exports__